<template>
  <div>
    <sign-up-container></sign-up-container>
  </div>
</template>

<script>

import SignUpContainer from "@/components/SignUpContainer";


export default {
  name: 'Sign',
  components: {
      SignUpContainer
  },
  props: {},
  data() {
    return {}
  },
}
</script>


